import ReactMarkdown, { type Components } from "react-markdown";
import remarkBreaks from "remark-breaks";

import { cn } from "@/lib/utils";
import "./markdown-content.css";

interface MarkdownRendererProps {
  content: string;
  className?: string;
  components?: Components;
}

export function MarkdownRenderer({
  content,
  className,
  components,
}: MarkdownRendererProps) {
  return (
    <div
      className={cn(
        "markdown-content text-muted-foreground max-w-xl",
        className,
      )}
    >
      <ReactMarkdown
        remarkPlugins={[remarkBreaks]}
        components={{
          a: ({ href, children }) =>
            href ? (
              <a
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                className="text-foreground underline decoration-current/30 underline-offset-2 hover:decoration-current"
              >
                {children}
              </a>
            ) : (
              <>{children}</>
            ),
          ...components,
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
}
